module.exports = __webpack_public_path__ + "img/Logo_FRANCESOIR.8a1fa277.png";